"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoreHistoryQuerySchema = exports.LICH_SU_THANG_MAC_DINH = exports.ScoreHistoryPointSchema = exports.ReportSummarySchema = exports.ReportIssueSchema = exports.ReportPageRowSchema = exports.BO_ROI_LY_DO_LABEL = exports.BoRoiLyDoSchema = exports.AlertSettingsSchema = exports.NGUONG_TUT_DIEM_MAC_DINH = exports.AlertListSchema = exports.AlertRowSchema = exports.AlertDetailSchema = exports.AlertKindSchema = exports.ALERT_KIND_CODES = exports.ALERT_KINDS = exports.ScanProgressSchema = exports.ScanBatchErrorSchema = exports.ScanBatchKindSchema = void 0;
exports.scanDone = scanDone;
const zod_1 = require("zod");
const api_1 = require("./api");
/**
 * Báo cáo và theo dõi định kỳ — spec SC-08.
 *
 * Ba thứ khác nhau gom vào một file vì chúng chỉ có nghĩa cùng nhau: hệ thống tự
 * quét theo lịch → phát hiện điểm tụt → sinh cảnh báo → và báo cáo là chỗ nhìn
 * lại toàn bộ. Tách ra ba file thì mỗi file là một mảnh không đứng một mình được.
 *
 * **Email nằm NGOÀI phạm vi** (spec SC-08 §5): chưa có SMTP nội bộ. Nơi nhận cảnh
 * báo là chuông trong ứng dụng. Đừng thêm trường `email` vào đây rồi để đó —
 * một trường luôn null là lời hứa mà giao diện sẽ đọc nhầm thành tính năng có thật.
 */
/* ────────────────────────────────────────────────────────────────────────────
 * Quét nền — spec SC-08 §4
 * ──────────────────────────────────────────────────────────────────────────── */
/**
 * Ai kích lượt quét này.
 *
 * `dinh-ky` là lượt do lịch hàng tuần chạy, không có người bấm. Phân biệt được
 * hai loại là điều kiện để trả lời "trang này tụt điểm từ lượt quét nào" — và để
 * màn tiến độ không hiện một lượt quét của hệ thống như thể người dùng vừa bấm.
 */
exports.ScanBatchKindSchema = zod_1.z.enum(['thu-cong', 'dinh-ky']);
exports.ScanBatchErrorSchema = zod_1.z.object({
    slug: zod_1.z.string(),
    code: zod_1.z.string(),
    error: zod_1.z.string(),
});
/**
 * Tiến độ một lượt quét cả danh sách.
 *
 * Trước spec này `POST /registry/scan-all` chạy ĐỒNG BỘ — đó là lý do phải đặt
 * `proxy_read_timeout 300s` ở reverse proxy, và là lý do có hẳn một lớp lỗi
 * `ScanStillRunningError` ở giao diện. Giờ lượt gọi trả về ngay với một `id`, còn
 * giao diện hỏi lại tiến độ theo nhịp.
 */
exports.ScanProgressSchema = zod_1.z.object({
    id: zod_1.z.string(),
    kind: exports.ScanBatchKindSchema,
    total: zod_1.z.number().int(),
    done: zod_1.z.number().int(),
    failed: zod_1.z.number().int(),
    /** Tối đa 20 lỗi đầu tiên — đủ để hiểu chuyện gì, không đủ để làm phình bản ghi */
    errors: zod_1.z.array(exports.ScanBatchErrorSchema),
    startedAt: zod_1.z.coerce.date(),
    finishedAt: zod_1.z.coerce.date().nullable(),
});
/** Lượt quét đã xong khi mọi việc đều đã chạy — kể cả khi tất cả đều lỗi. */
function scanDone(p) {
    return p.finishedAt !== null || p.done + p.failed >= p.total;
}
/* ────────────────────────────────────────────────────────────────────────────
 * Cảnh báo — spec SC-08 §5
 * ──────────────────────────────────────────────────────────────────────────── */
/**
 * Loại cảnh báo. Hiện đúng MỘT loại.
 *
 * Khai bằng bảng tra thay vì một chuỗi tự do để chỗ hiển thị không phải tự chế
 * câu chữ — và để loại thứ hai (khi có) không đẻ thêm một nhánh `if` ở giao diện.
 */
exports.ALERT_KINDS = {
    'diem-tut': {
        label: 'Điểm SEO tụt',
        /** Câu mở đầu của thông báo; phần số liệu do dữ liệu điền vào sau */
        giaiThich: 'Điểm SEO của trang giảm quá ngưỡng đã đặt so với lần quét ngay trước.',
    },
};
exports.ALERT_KIND_CODES = Object.keys(exports.ALERT_KINDS);
exports.AlertKindSchema = zod_1.z.enum(exports.ALERT_KIND_CODES);
/**
 * Chi tiết của cảnh báo tụt điểm.
 *
 * `mucMoiHong` là phần QUAN TRỌNG NHẤT: "điểm tụt 15" không nói cho người phụ
 * trách biết phải làm gì, còn "Meta Title và Canonical vừa chuyển sang không đạt"
 * thì nói được. Spec SC-08 §5 gạch đầu dòng cuối yêu cầu đúng thứ này.
 */
exports.AlertDetailSchema = zod_1.z.object({
    tu: zod_1.z.number().int(),
    den: zod_1.z.number().int(),
    giam: zod_1.z.number().int(),
    mucMoiHong: zod_1.z.array(zod_1.z.object({ code: zod_1.z.string(), label: zod_1.z.string() })).default([]),
});
exports.AlertRowSchema = zod_1.z.object({
    id: zod_1.z.number().int(),
    kind: exports.AlertKindSchema,
    pageSlug: zod_1.z.string(),
    pageCode: zod_1.z.string(),
    detail: exports.AlertDetailSchema,
    readAt: zod_1.z.coerce.date().nullable(),
    createdAt: zod_1.z.coerce.date(),
});
exports.AlertListSchema = zod_1.z.object({
    rows: zod_1.z.array(exports.AlertRowSchema),
    /**
     * Số chưa đọc tính trên TOÀN BỘ, không trên danh sách vừa trả — con số trên
     * chuông phải đúng kể cả khi danh sách bị cắt còn 20 dòng.
     */
    soChuaDoc: zod_1.z.number().int(),
});
/**
 * Ngưỡng mặc định: tụt từ 10 điểm trở lên mới sinh cảnh báo (spec SC-08 §5).
 *
 * Trùng ngưỡng của `diem-tut` ở spec SC-19 — CÓ CHỦ ĐÍCH và không được để lệch:
 * hai chỗ nói về cùng một hiện tượng, một cái ghi vào dòng thời gian, một cái gõ
 * cửa người phụ trách. Ngưỡng khác nhau thì dòng thời gian và chuông báo mâu
 * thuẫn nhau, và không ai đoán được cái nào đúng.
 */
exports.NGUONG_TUT_DIEM_MAC_DINH = 10;
/** Ngưỡng sinh cảnh báo, đặt được ở màn quản trị (spec SC-08 §5). */
exports.AlertSettingsSchema = zod_1.z.object({
    nguongTutDiem: zod_1.z.coerce.number().int().min(1).max(100).default(exports.NGUONG_TUT_DIEM_MAC_DINH),
});
/* ────────────────────────────────────────────────────────────────────────────
 * Báo cáo cấp danh sách — spec SC-08 §3.1
 * ──────────────────────────────────────────────────────────────────────────── */
/** Vì sao một trang bị coi là bỏ rơi — spec SC-08 §3.1 gạch đầu dòng 3. */
exports.BoRoiLyDoSchema = zod_1.z.enum(['chua-quet', 'lau-chua-quet', 'diem-thap-khong-doi']);
exports.BO_ROI_LY_DO_LABEL = {
    'chua-quet': 'Chưa quét lần nào',
    'lau-chua-quet': 'Lâu rồi chưa quét lại',
    'diem-thap-khong-doi': 'Điểm thấp nhưng không nhích lên qua các lần quét',
};
exports.ReportPageRowSchema = zod_1.z.object({
    slug: zod_1.z.string(),
    code: zod_1.z.string(),
    publicUrl: zod_1.z.string(),
    seoScore: zod_1.z.number().int().nullable(),
    prevScore: zod_1.z.number().int().nullable(),
    /** `seoScore - prevScore`; null khi thiếu một trong hai */
    delta: zod_1.z.number().int().nullable(),
    problemCount: zod_1.z.number().int().nullable(),
    lastScannedAt: zod_1.z.coerce.date().nullable(),
    ownerName: zod_1.z.string().nullable(),
    /** Chỉ có ở danh sách trang bị bỏ rơi */
    lyDo: exports.BoRoiLyDoSchema.nullable().default(null),
});
/**
 * Một mục kiểm tra hay hỏng trên cả danh sách.
 *
 * Câu hỏi nó trả lời: *"sửa cái gì trước để được nhiều trang cùng lúc"* — đó là
 * lý do sắp theo SỐ TRANG dính chứ không theo mức nặng nhẹ.
 */
exports.ReportIssueSchema = zod_1.z.object({
    code: zod_1.z.string(),
    label: zod_1.z.string(),
    soTrang: zod_1.z.number().int(),
    /** Phần trăm trang đã quét đang dính mục này, làm tròn */
    tiLe: zod_1.z.number().int(),
});
exports.ReportSummarySchema = zod_1.z.object({
    scope: api_1.RegistryScopeSchema,
    tongSoTrang: zod_1.z.number().int(),
    daQuet: zod_1.z.number().int(),
    chuaQuet: zod_1.z.number().int(),
    /** Trung bình điểm SEO, đã loại trang nghi đọc hụt (spec SC-15 §3.2) */
    diemTrungBinh: zod_1.z.number().int().nullable(),
    /** Trung bình của LẦN QUÉT TRƯỚC trên đúng tập trang đó — để so kỳ với kỳ */
    diemTrungBinhKyTruoc: zod_1.z.number().int().nullable(),
    boQuaVìDocHut: zod_1.z.number().int(),
    soCanhBaoChuaDoc: zod_1.z.number().int(),
    tot: zod_1.z.array(exports.ReportPageRowSchema),
    kem: zod_1.z.array(exports.ReportPageRowSchema),
    tutNhieuNhat: zod_1.z.array(exports.ReportPageRowSchema),
    boRoi: zod_1.z.array(exports.ReportPageRowSchema),
    vanDeHayGap: zod_1.z.array(exports.ReportIssueSchema),
    /** Mốc dựng báo cáo — in lên đầu file xuất ra */
    taoLuc: zod_1.z.coerce.date(),
});
/**
 * Một điểm trên biểu đồ lịch sử điểm.
 *
 * Lấy từ ba CỘT của bảng `Scan`, không từ `detail` — `detail` bị xoá khi rút gọn
 * theo spec SC-13 §2.2, còn biểu đồ phải liền mạch nhiều năm.
 */
exports.ScoreHistoryPointSchema = zod_1.z.object({
    scanId: zod_1.z.number().int(),
    scannedAt: zod_1.z.coerce.date(),
    seoScore: zod_1.z.number().int(),
    technicalScore: zod_1.z.number().int(),
    contentScore: zod_1.z.number().int(),
});
/**
 * Số tháng lịch sử điểm mặc định lấy về cho biểu đồ.
 *
 * 12 tháng vì đó là mốc chính sách lưu giữ chuyển từ "một điểm mỗi tuần" sang
 * "một điểm mỗi tháng" (spec SC-13 §2.2) — quá mốc đó thì biểu đồ đổi mật độ
 * giữa chừng và người xem tưởng hệ thống bỏ quét.
 */
exports.LICH_SU_THANG_MAC_DINH = 12;
exports.ScoreHistoryQuerySchema = zod_1.z.object({
    thang: zod_1.z.coerce.number().int().min(1).max(60).default(exports.LICH_SU_THANG_MAC_DINH),
});
//# sourceMappingURL=bao-cao.js.map